export const stylesStepRadioTitle = {
  fontSize: 'h3.fontSize',
  fontWeight: 'fontWeightSemiBold',
};
